var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.states,"readonly":_vm.readOnly,"label":"State","dense":_vm.dense},on:{"input":_vm.emitSelection},model:{value:(_vm.selectedState),callback:function ($$v) {_vm.selectedState=$$v},expression:"selectedState"}})
}
var staticRenderFns = []

export { render, staticRenderFns }